import { useSelector } from 'react-redux';
import { useI18n } from 'services/i18n/i18n.hooks';
import { selectUserBalance } from 'services/user/user.selectors';
import CompactVariant from './partials/CompactVariant.component';
import ExpandedVariant from './partials/ExpandedVariant.component';

type SignedInUserToolbarVariants = 'expanded' | 'compact';

type SignedInUserToolbarProps = {
  variant: SignedInUserToolbarVariants;
  onDropdownToggle?: (expanded: boolean) => void;
  onPanelToggle?: (expanded: boolean) => void;
  isPanelExpanded?: boolean;
};

export default function SignedInUserToolbar({
  variant,
  onDropdownToggle,
  onPanelToggle,
  isPanelExpanded,
}: SignedInUserToolbarProps) {
  const userBalance = useSelector(selectUserBalance);

  const {
    formatters: { formatCurrency },
  } = useI18n();

  const realBonus = userBalance.bonusTypeBalances?.find(
    ({ bonusType }) => bonusType === 'BS',
  )?.balance;
  const formattedBonus = formatCurrency(realBonus ?? 0, {
    removeWhiteSpaces: true,
  });

  const formattedBalance = formatCurrency(userBalance.realCashBalance, {
    removeWhiteSpaces: true,
  });

  switch (variant) {
    case 'compact':
      return (
        <CompactVariant
          formattedBalance={formattedBalance}
          formattedBonus={formattedBonus}
          onDropdownToggle={onDropdownToggle}
          onPanelToggle={onPanelToggle}
          isPanelExpanded={isPanelExpanded}
        />
      );
    case 'expanded':
      return (
        <ExpandedVariant
          formattedBalance={formattedBalance}
          formattedBonus={formattedBonus}
          onDropdownToggle={onDropdownToggle}
          onPanelToggle={onPanelToggle}
          isPanelExpanded={isPanelExpanded}
        />
      );
  }
}
